export default {
  mainVenue: [
    {
      time: '13:10-13:40',
      affair: {
        type: '互动对话',
        title: '王石：70岁以后的探险，从运动到环保',
        speakers: [
          {
            name: '王石',
            title: '万科创始人',
          },
        ],
      },
    },
    {
      time: '10:40-14:10',
      affair: {
        type: '互动对话',
        title: '张伟丽：从中国的到世界的',
        speakers: [
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
        ],
      },
    },
    {
      time: '14:10-14:50',
      affair: {
        type: '圆桌论坛',
        title: '比赛场：特殊的体育大年',
        speakers: [],
      },
    },
    {
      time: '14:50-15:10',
      affair: {
        type: '圆桌论坛',
        title: '营销场：重估体育力量',
        speakers: [],
      },
    },
    {
      time: '15:20-16:00',
      affair: {
        type: '圆桌论坛',
        title: '坚果场：胜利与觉醒',
        speakers: [],
      },
    },
    {
      time: '16:00-16:40',
      affair: {
        type: '圆桌论坛',
        title: '创业场：持久战',
        speakers: [],
      },
    },
    {
      time: '16:50-17:30',
      affair: {
      type: '圆桌论坛',
      title: '新奇场：生活方式驱动力',
      speakers: [],
      },
    },

  ],
  parallelVenue: [
    // {
    //   time: '14:30-14:40',
    //   affair: {
    //     type: '开场',
    //     title: '',
    //     speakers: [],
    //   },
    // },
    {
      time: '15:40-16:20',
      affair: {
        type: '年度产业人物',
        title: '',
        speakers: [
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },

    {
      time: '14:40-15:00',
      affair: {
        type: '年度创新品牌',
        title: '',
        speakers: [],
      },
    },
    {
      time: '15:00-15:40',
      affair: {
        type: '年度营销品牌',
        title: '',
        speakers: [
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },

  ],
  awards: [
    {
      time: '',
      affair: {
        type: '中国体育产业年度产业人物',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '中国体育产业年度营销奖',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '中国体育产业年度创新奖',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
  workshop: [
    {
      time: '',
      affair: {
        type: '体育创新与城市发展',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '体育营销的技术变革',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '体育科技的颠覆应用',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
};
